import { Box } from '@modusign/design-system';
import { useSelector } from 'react-redux';
import isEmail from 'validator/lib/isEmail';

import { getFormattedSouthKoreaPhoneNumber } from '@app/libs/inputFormat';
import { getDocument } from '@app/store/signingProgressInformation/selectors';

function CarbonCopies() {
  const document = useSelector(getDocument);

  return (
    <div className="box-5x">
      <h5 className="space-3x">참조자 정보</h5>
      <Box mb={4}>
        {document.carbonCopies
          .map(
            ({ contact }) =>
              `<${isEmail(contact) ? contact : getFormattedSouthKoreaPhoneNumber(contact)}>`
          )
          .join(', ')}
      </Box>
    </div>
  );
}

export default CarbonCopies;
